export default __webpack_public_path__ + "static/media/brands.b8264308.png";